import { ModuleDataType } from 'types/interfacePreviewTypes';

export const wippe_cxiv_schwarz: ModuleDataType = {
  outputPdf: null,
  userUploadedFilesDescriptions: [],
  userUploadedFiles: [],
  id: null,
  projectTitle: '',
  configuratorPreviewScreenshot: null,
  isSubmitted: false,
  createdAt: null,
  updatedAt: null,
  userInfo: {
    name: '',
    lastname: '',
    firma: '',
    email: '',
    telephoneNumber: '',
    clientNumber: null,
    comments: '',
    country: '',
    postalCode: '',
  },

  background: {
    active: true,
    type: 'image',
    imageUrl:
      'https://firebasestorage.googleapis.com/v0/b/miunskekonfigurator.appspot.com/o/images%2Fwippen-images%2Fmar-2-2025%2Fcxiv_schwarz.png?alt=media&token=68901fc7-b419-4a84-aff6-04d333ae51a0',
    thumbnail: null,
  },

  rotation: '0',
  module: 'Contura XIV - Wippe schwarz',
  version: '1.0',
  elements: {
    symbols: {
      0: {
        active: true,
        color: '#ffffff',
        icon: null,

        variant: 'bottom',
      },
      1: {
        active: true,

        color: '#ffffff',
        icon: null,
        variant: 'top',
      },
    },
  },
};
